export const AssetsPermissions = {
  ViewandsearchinPropertyManagementAssets: {
    permissionsId: '24af20b8-6568-4e46-c9d2-08d94f66fc61',
    permissionsName: 'View and search in  Property Management Assets',
    componentsId: null,
    components: null,
  },

  ShowAssets: {
    components: null,
    componentsId: null,
    permissionsId: 'd0fcf345-a5f5-4c89-932e-08d967db92be',
    permissionsName: 'Show Assets'
  },


  CreateAssets: {
    components: null,
    componentsId: null,
    permissionsId: 'd94b694f-0024-4fc7-932f-08d967db92be',
    permissionsName: 'Create Assets'
  },

  ViewAllUnits: {
    components: null,
    componentsId: null,
    permissionsId: '3f88d1f8-a301-456e-9330-08d967db92be',
    permissionsName: 'view all units'
  },

  ViewAllcontacts: {
    components: null,
    componentsId: null,
    permissionsId: '38f9dddf-4920-4e87-9331-08d967db92be',
    permissionsName: 'View All contacts'

  },
  ViewAllPortfolios: {
    components: null,
    componentsId: null,
    permissionsId: '059d0a3c-0dbf-4522-9332-08d967db92be',
    permissionsName: 'View all portfolios'
  },
  EditAssets:
  {
    permissionsId: '0316d156-5f0b-4154-0d72-08d96c602a6b',
    permissionsName: 'Edit Assets',
    componentsId: null,
    components: null
  },
  DeleteAssets:
  {
    permissionsId: '8abf0977-9bdf-4720-0d73-08d96c602a6b',
    permissionsName: 'Delete Assets',
    componentsId: null,
    components: null
  },


};
